<template>
  <div class="talent-module pt-4">
    <div class="talent-upload d-flex flex-column justify-content-center align-items-center mx-auto">
      <h3 class="mb-4">
        فستیوال خوانندگی
      </h3>

      <input
          type="file"
          style="display: none"
          ref="fileInput"
          @change="onFilePicked"/>

      <p>
        لطفا یک ویدیو با مدت زمان نهایتا 1 دقیقه از اجرا خود با کیفیت مطلوب ضبط و از طریق فرم زیر آپلود نمایید
      </p>
      <div v-if="list.status == 2">
        <p>
          در صورت آپلود مجدد، ویدیو قبلی حذف خواهد شد.
        </p>

        <div class="video-container" v-if="list.url">
          <video width="320" height="240" controls preload="none">
            <source :src="`https://kishoto.ir/dtr/approid/${list.url}`" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>

      </div>
      <div class="talent-hr mt-4 mb-4"></div>
      
      <div class="vote-image d-flex justify-content-center w-100 mb-4" @click="selectVideo">
        <img src="~@/assets/img/talent/talents1_uploadbtn.png" alt="">
      </div>

      <p class="mt-3">{{gupload}}</p>
      
    </div>




    <div class="talent-image">
        <img src="~@/assets/img/talent/talents1_vec.png">
    </div>


  </div>
</template>

<script>

import PlusIcon from 'vue-material-design-icons/Plus.vue';

import store from "@/store";

export default {
  data() {
    return {
      list: [],
      file: null,
      fileUrl: null,
      gupload:'با کلیک روی کلید بالا فایل ویدیوی خود را انتخاب نمایید',

    };
  },
  components:{
    PlusIcon
  },
  created() {
      this.getVoteStart();
  },
  methods: {
    async getVoteStart() {
      let fd = new FormData();
      fd.append("vid", this.$route.params.id);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("single_upload_start",fd);
      console.table(response);
      if (response) {
        this.list = response;
      }
    },
    async selectVideo(){
            if(this.list.status == 1 || this.list.status == 2){
              this.$refs.fileInput.click();
              this.gupload = 'در حال انتخاب ویدیو شما';

            }else{
              this.$toast.open({
                message: 'شما مجاز به آپلود ویدیو نمی باشید.',
                type: 'error',
              });
            }
    },
    onFilePicked (event) {
      const files = event.target.files
      let filename = files[0].name
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.fileUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.file = files[0]
      if(this.file){
        this.uploadVideo();
      }
    },
    async uploadVideo(){
      let fd = new FormData();
      fd.append("vid", this.$route.params.id);
      fd.append("file", this.file);
      fd.append("token", store.state.login.loginTempToken);
      fd.append("flag","vote");

      const response = await this.$ApiServiceLayer.post("uploader",fd);
      console.table(response);
      if (response) {
        this.list = response;
        this.getVoteStart();
      }

      this.$toast.open({
        message: 'ویدیو شما با موفقیت آپلود شد.',
        type: 'success',
      });

      this.gupload ='با کلیک روی کلید بالا فایل ویدیوی خود را انتخاب نمایید' ;

    }
  },
};
</script>

<style lang="scss" scoped>
.talent-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/talent_back.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px;
  direction: rtl;
  .talent-image{
    position: absolute;
    bottom: 0;
    width: 100%;
    img{
      width: 100%;
    }
  }
  .talent-upload{
       width: 95%;
       background: #ffff;
       border-radius: 14px;
       padding: 20px 20px 0px 20px;
        z-index: 1 !important;
        position: relative;
    .vote-image{
      img{
        width: 67%;
        height: 100%;
        /*padding-top: 19px;*/
        /*padding-bottom: 25px;*/
      }
    }
    .talent-hr{
        width: 100%;
        height: 1px;
        background: #9e9e9e;
    }
    .video-container{
      video{
        height: 172px;
        width: 84%;
        margin: 0 auto;
        display: flex;
      }
    }
  }
}
</style>
